export const WIDGET = 'WIDGET';
